import React, { useState, useEffect } from 'react';
import { Grid, SvgIcon } from '../';
import { $FormHelperText, $Input, $InputLabel } from '../newInput';
import { $FormElementControl } from '../newFormElement/styles';
import { $Autocomplete, AutocompleteGlobalStyles } from './styles';
const getMatchPriority = (label, input) => {
    if (label.startsWith(input))
        return 0;
    const words = label.split(/\s+/);
    if (words.some((word) => word.startsWith(input)))
        return 1;
    return 2;
};
const buildOptions = (items, value, onCreateItem, withNone, name) => {
    const selectedValues = value
        ? (Array.isArray(value) ? value : [value]).map((v) => v.value)
        : [];
    const base = withNone ? [{ label: 'None', value: '' }, ...items] : [...items];
    const pinned = base.filter((item) => selectedValues.includes(item.value));
    const rest = base.filter((item) => !selectedValues.includes(item.value));
    const sorted = [...pinned, ...rest];
    return onCreateItem
        ? [{ label: `Create new ${name}`, value: 'create-new' }, ...sorted]
        : sorted;
};
export const AutocompleteInput = ({ title = '', multiple, description, error, errorMsg, placeholder, value, name, required, disabled, onChange, onInputChange = () => null, onCreateItem, onEditItem, onDuplicateItem, items = [], withNone, }) => {
    const getLabel = (v) => v && !Array.isArray(v) ? v.label : '';
    const [inputValue, setInputValue] = useState(getLabel(value));
    useEffect(() => { setInputValue(getLabel(value)); }, [value]);
    const handleOpen = () => setInputValue('');
    const handleClose = () => setInputValue(getLabel(value));
    const handleInputChange = (_event, newValue, reason) => {
        setInputValue(newValue);
        if (reason === 'input')
            onInputChange(_event, newValue);
    };
    const selectedValues = value
        ? (Array.isArray(value) ? value : [value]).map((v) => v.value)
        : [];
    const filterOptions = (options, { inputValue }) => {
        if (!inputValue)
            return options;
        const input = inputValue.toLowerCase();
        const opts = options;
        const filtered = opts.filter((option) => {
            if (option.value === 'create-new')
                return true;
            const label = (typeof option.label === 'string' ? option.label : '').toLowerCase();
            const val = option.value.toString().toLowerCase();
            return label.includes(input) || val.includes(input);
        });
        return filtered.sort((a, b) => {
            if (a.value === 'create-new')
                return -1;
            if (b.value === 'create-new')
                return 1;
            const aSelected = selectedValues.includes(a.value);
            const bSelected = selectedValues.includes(b.value);
            if (aSelected && !bSelected)
                return -1;
            if (!aSelected && bSelected)
                return 1;
            const aLabel = (typeof a.label === 'string' ? a.label : '').toLowerCase();
            const bLabel = (typeof b.label === 'string' ? b.label : '').toLowerCase();
            const diff = getMatchPriority(aLabel, input) - getMatchPriority(bLabel, input);
            return diff !== 0 ? diff : aLabel.localeCompare(bLabel);
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(AutocompleteGlobalStyles, null),
        React.createElement($FormElementControl, null,
            React.createElement($InputLabel, { shrink: true },
                title,
                required && '*'),
            React.createElement($Autocomplete, { multiple: multiple, disabled: disabled, filterOptions: filterOptions, options: buildOptions(items, value, onCreateItem, withNone, name), getOptionSelected: (option, val) => option.value === val.value, getOptionLabel: (option) => option.label, renderInput: (params) => {
                    const { InputLabelProps, InputProps, ...rest } = params;
                    return React.createElement($Input, { placeholder: placeholder, ...params.InputProps, ...rest, error: error, autoComplete: 'new-password', name: name });
                }, renderOption: !!onEditItem || !!onDuplicateItem || !!onCreateItem ?
                    (option) => (React.createElement(React.Fragment, null,
                        option.value === 'create-new' ? null : option.label,
                        onCreateItem && option.value === 'create-new' &&
                            React.createElement(Grid, { container: true, wrap: 'nowrap', alignItems: 'center', onClick: (e) => {
                                    e.stopPropagation();
                                    onCreateItem();
                                } },
                                option.label,
                                React.createElement(SvgIcon, { name: 'plus', clickable: true, size: 16, color: '#757778' })),
                        onEditItem && !!option.value && option.value !== 'create-new' && React.createElement(SvgIcon, { name: 'altEdit', clickable: true, size: 16, color: '#757778', onClick: (e) => {
                                e.stopPropagation();
                                onEditItem(option.value);
                            } }),
                        onDuplicateItem && !!option.value && option.value !== 'create-new' && React.createElement(SvgIcon, { name: 'content-copy', clickable: true, size: 16, color: '#757778', onClick: (e) => {
                                e.stopPropagation();
                                onDuplicateItem(option.value);
                            } })))
                    : undefined, disableClearable: true, value: value, inputValue: inputValue, onOpen: handleOpen, onClose: handleClose, onChange: onChange, onInputChange: handleInputChange }),
            (errorMsg || description) &&
                React.createElement($FormHelperText, { error: error }, errorMsg || description))));
};
